import React from 'react';

import {
  AddWidgetModalContainerProps,
  type WidgetContainerProps,
  WidgetDefinitionNew,
  widgetRepositoryContext,
  type WidgetType,
} from '@neptune/shared/widgets-domain';

export const useWidgetRepository = () => {
  const context = React.useContext(widgetRepositoryContext);

  const getAvailableWidgetDefinitions = React.useCallback((): WidgetDefinitionNew[] => {
    if (!context) {
      return [];
    }

    return context.metadataList;
  }, [context]);

  const getConfiguringComponent = React.useCallback(
    (widgetType: WidgetType): React.ComponentType<AddWidgetModalContainerProps> | null => {
      if (!context) {
        return null;
      }

      return context.configuringComponents[widgetType] ?? null;
    },
    [context],
  );

  const getRenderingComponent = React.useCallback(
    (widgetType: WidgetType): React.ComponentType<WidgetContainerProps> | null => {
      if (!context) {
        return null;
      }

      return context.renderingComponents[widgetType] ?? null;
    },
    [context],
  );

  return {
    getAvailableWidgetDefinitions,
    getConfiguringComponent,
    getRenderingComponent,
  };
};
